// @flow
import React from "react";
import Testimonials from "../../../common/Testimonials";

type $Props = {
  testimonials: Array<Object>,
};

const HomeTestimonials = ({ testimonials }: $Props) => {
  return <Testimonials testimonials={testimonials} />;
};

export default HomeTestimonials;
